import { getBankingMenu } from './bankingMenu';
import { getComplianceMenu } from './complianceMenu';
import { getDashboardMenu } from './dashboardMenu';
import { getDocumentsMenu } from './documentsMenu';
import { getFinanceHubMenu } from './financeHubMenu';
import { getInvoicingMenu } from './invoicingMenu';
import { getMoneyMenu } from './moneyMenu';
import { getMyBusinessMenu } from './myBusinessMenu';
import { getTaxServicesMenu } from './taxServicesMenu';
import { getWebToolsMenu } from './webToolsMenu';
import { filterByNotEmpty } from '../utils/menu';

/**
 * Get the menu config for the business entity.
 *
 * @param {{
 *  businessEntityUuid: string
 *  email: string
 *  entitlements: Set<string>
 *  ldFlags: object
 * }} params
 *
 * @returns {Array}
 */
export function getMenuConfig(params) {
  if (!params.businessEntityUuid) {
    return [];
  }

  const menu = [
    getDashboardMenu(params),
    getComplianceMenu(params),
    getFinanceHubMenu(params),
    getDocumentsMenu(params),
    getBankingMenu(params),
    getMoneyMenu(params),
    getInvoicingMenu(params),
    getTaxServicesMenu(params),
    getWebToolsMenu(params),
    getMyBusinessMenu(params)
  ];

  return menu.filter(filterByNotEmpty);
}
